import { ref, watch } from 'vue';
import { useStore } from './store';

export function useAppMobileHelpers() {
    const store = useStore();
    const metaRef = ref<HTMLMetaElement | null>(null);
    watch(
        () => store.isMobileReady,
        isReady => {
            if (isReady) {
                metaRef.value ??= document.createElement('meta');
                metaRef.value.name = 'viewport';
                metaRef.value.content = 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover';
                document.head.appendChild(metaRef.value);
            } else if (metaRef.value) {
                document.head.removeChild(metaRef.value);
                metaRef.value = null;
            }
        }
    );
}
